import React, { useEffect, useState } from 'react';
import {
    List,
    ListItem,
    Icon,
    Page,
    Button, NavLeft, NavTitle, NavRight, Navbar, Card
} from "framework7-react";
import { getUserAuthData, setDefaultLang, setCurrentAtagLocal, getCurrentAtagLocal } from "../auth/authHelper";
import { MainToolBar } from "../MainLayout/MainToolBar";
import {
    setStorageCurrentOperator,
    setDefaultAtag,
    getStoragedCurrentOperator,
    getStoragedOperatorInfo,
    getDefaultAtag,
    OperatorInfo,
    getDefaultLang
} from "../auth/authHelper";
import { useAuth } from "../auth/AuthProvider";
import { useTranslation } from "react-i18next";
import {User} from "./components/User";
import {Withdraw} from "../Dashboard/Withdraw/Withdraw";
import LanguageSwitcher from "../i18n/LanguageSwitcher";
import {ATagSelector} from "./components/ATagSelector";

export const Profile = () => {
    const { t } = useTranslation();
    const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;
    const storedOperatorValue = getStoragedCurrentOperator();
    const userData = getUserAuthData();
    const { logout } = useAuth();
    let defaultLanguage = getDefaultLang();
    const [currentOperator, setCurrentOperator] = useState<string>('');
    const storedAtag = getCurrentAtagLocal();
    const defaultAtag = getDefaultAtag();
    const initialAtag = storedAtag?.length > 0 ? storedAtag : defaultAtag;
    const [currentAtag, setCurrentAtag] = useState<string>(initialAtag);
    const handleChangeAtage = (customAtag: string) => {
        setCurrentAtag(customAtag);
        setCurrentAtagLocal(customAtag);
    };
    const [currentBrandInfo, setCurrentBrandInfo] = useState<OperatorInfo>();
    const storagedOperator = getStoragedCurrentOperator();
    const handleChangeOperator = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newOperator = e.target.value;
        setCurrentOperator(newOperator);
        await setStorageCurrentOperator(newOperator);
        setDefaultAtag(newOperator + 'Atag');
        setCurrentAtagLocal(newOperator + 'Atag');
        const updatedInfo = getStoragedOperatorInfo();
        setCurrentBrandInfo(updatedInfo);
        if (updatedInfo?.language) {
            setDefaultLang(updatedInfo?.language)
        }
    };
    useEffect(() => {
        if (storagedOperator) {
            setCurrentOperator(storagedOperator);
            const operatorInfo = getStoragedOperatorInfo();
            setCurrentBrandInfo(operatorInfo);
        }
    }, []);
    useEffect(() => {
        setCurrentAtag(initialAtag);
    }, [initialAtag]);
    return (
        <Page>
            <Navbar style={{ height: "60px" }}>
                <NavLeft />
                <NavTitle>
                    <img
                        src={toAbsoluteUrl(`/img/operator_logo/logo_${storedOperatorValue}.webp`)}
                        onError={(e) => {
                            e.currentTarget.src = toAbsoluteUrl(`/img/operator_logo/betstack_logo.png`);
                        }}
                        alt="Logo"
                        style={{ height: "30px" }}
                    />
                </NavTitle>
                <NavRight />
            </Navbar>
            <div style={{paddingBottom: "60px"}}>
                <User userData={userData} atag={currentAtag} />
                <Card title={t('profile.balance') + ' 1.250.00 ' + `${currentBrandInfo?.currency}`}>
                    <Withdraw />
                </Card>
                <Card title={t('profile.settings')}>
                    <List  dividersIos outlineIos strongIos>
                        <ListItem
                            title={`${t("profile.changeOperator")}`}
                            smartSelect
                            smartSelectParams={{ openIn: 'sheet' }}
                        >
                            <Icon material="home" slot="media" />
                            {
                                storagedOperator ?
                                    <select
                                        name="operator"
                                        value={storagedOperator}
                                        onChange={handleChangeOperator}
                                    >
                                        {
                                            userData.operators.map((item: string, index: number) => {
                                                return (<option key={index} value={item}>{item}</option>)
                                            })
                                        }
                                    </select>
                                    : null
                            }
                        </ListItem>
                    </List>
                    {
                        currentAtag ?
                            <ATagSelector currentAtag={currentAtag} defaultValue={defaultAtag} onChange={handleChangeAtage} />
                            : null
                    }
                    {
                        currentBrandInfo && (
                            <LanguageSwitcher languages={currentBrandInfo?.languages} language={defaultLanguage}
                                              operator={currentOperator}/>
                        )
                    }
                </Card>
                <Button large style={{color: '#00000073'}} onClick={logout}>
                    {t('profile.logout')}
                    <Icon material="navigate_next" slot="media"  />
                </Button>
            </div>
            <MainToolBar/>
        </Page>
    );
};
